export * from './thunks/apps';
export * from './thunks/auth';
export * from './thunks/documents';
export * from './thunks/eventStats';
export * from './thunks/mangoPay';
export * from './thunks/organizationConfiguration';
export * from './thunks/payment';
export * from './thunks/statistics';

export const initStore = () => {
  return (dispatch, getState) => {
  };
};



// WEBPACK FOOTER //
// ./app/actions/thunks.js